

  

  // Shortcircuit variable
  let triggered = false;


//   if (typeof ScrollExecute != "function")
//   {
    function ScrollExecute() {
        let moreButon = $('.productgrid--items li.next-product a').parent('li');

        // Get URL from the loadmore button
        let nextUrl = $('.productgrid--items li.next-product a').data("href");


        // Button position when AJAX call should be made one time
        if (triggered == false) {

          // Trigger shortcircuit to ensure AJAX only fires once
          triggered = true;

          // Make ajax call to next page for load more data
          $.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function() {
              moreButon.html("<span>Loading...</span>");
            }
          })
          .done(function(data) {      
            moreButon.remove();

            $(document).trigger('load');

            // Append data
            $('.productgrid--items').append( $(data).find('.productgrid--items').html() );

            // On success, reset shortcircuit
            triggered = false

            $('.productgrid--items li.next-product a').bind('click')
          });
        }
    }

    $(document).on("click", ".productgrid--items li.next-product a", function(e){
      e.preventDefault();
      e.stopPropagation();

      ScrollExecute();

      $(this).unbind('click');
    }); 
    
//   }
